import { default as IndexPage, getServerSideProps as baseGetServerSideProps } from './[lang]/index';

export default IndexPage;

export const getServerSideProps = baseGetServerSideProps;
